import * as React from 'react'
import Layout from '../../components/layout'
import { PageProps, graphql, useStaticQuery } from 'gatsby';
import { H2, HTML, Img, Link, Text } from '../../common';
 
import ContentSplit from '../../components/contentSplit';
import issue48 from '../../images/48.jpg';
import logo from '../../images/faunus-logo.jpg';
import Seo from '../../components/seo';
import issues from '../../images/faunus-issues.jpg';
import ContentCentered from '../../components/contentCentered';

const FaunusPage: React.FC<PageProps> = (props) => {
    const data = useStaticQuery(graphql`
        query {
            markdownRemark(fileAbsolutePath: { regex: "/faunus/faunus.md/" }) {
                html
            }   
        }
    `);

    const faunus = data.markdownRemark;

    return (
        <Layout title="Biography" activeNav='/biography/'>
            <>
            <ContentSplit theme='white' leftContent={
                <>
                    <Img src={logo} style={{ maxWidth: 600, marginBottom: 20 }}/>
                    <HTML dangerouslySetInnerHTML={{ __html: faunus.html }} />
                    
                </>
            } rightContent={<Img src={issue48} />} /> 
            <ContentCentered theme='gold' content={
                    <HTML id='back-issues'>
                        <H2>Looking for back issues?</H2>
                        <Text>For those members wishing to expand or complete their physical <em>Faunus</em> collection, we do have a small assortment of left over issues, priced at £10 each. Older editions of <em>Machenalia</em>, a 40-50 page zine stuffed with interesting articles, discussion and reviews are also available, at £5 each. Prices include UK postage, but worldwide postage can be calculated on request. Please write to John Galantini, via the <Link to='/contact'>Contact page</Link>.</Text>
                    </HTML>
                }
                />
            </>
        </Layout>
    )
}

export const Head = () => <Seo title="Faunus: Our Journal" img={issues} />

export default FaunusPage;